import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/pages/home/data";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="常见问题"
          title="投稿前后，最常被问到的几个问题"
          description="如果你的问题不在下面，可以带着查询编号或初步材料直接联系我们，我们会说明对应条款与建议的处理方式。"
          align="center"
        />

        <div className="mt-10 md:mt-12 divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-heading text-sm font-bold text-primary-500 mt-0.5">
                        Q{String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                        {item.q}
                      </span>
                    </span>
                    <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-700 text-lg">
                      <i
                        className={isOpen ? "ri-subtract-line" : "ri-add-line"}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5 -mt-1">
                    <p className="pl-0 md:pl-10 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}